"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageActionsProvider = exports.usePageActions = void 0;
var React = __importStar(require("react"));
var react_1 = require("react");
var sli_react_metrics_1 = require("@cvent/sli-react-metrics");
var PageLoadProvider_1 = require("./PageLoadProvider");
var usePageActions = function () { return (0, react_1.useContext)(sli_react_metrics_1.PageActionsContext); };
exports.usePageActions = usePageActions;
var PageActionsProvider = function (_a) {
    var children = _a.children;
    var _b = (0, PageLoadProvider_1.usePageLoadApi)(), url = _b.url, pathname = _b.pathname, registerPageAction = _b.registerPageAction, unregisterPageAction = _b.unregisterPageAction, registerPageActionCallback = _b.registerPageActionCallback;
    var _c = (0, sli_react_metrics_1.usePageActions)(), getBaseProps = _c.getBaseProps, startReactAction = _c.startAction, endReactAction = _c.endAction, trackReactAction = _c.trackAction, updateMetricData = _c.updateMetricData, track = _c.track, trackKeepAlive = _c.trackKeepAlive;
    /**
     * Function to allow pages to start measuring custom page actions. Each page has different
     * requirements on what actions it needs to track and can do so by invoking this function
     * in combination with the endAction function below
     *
     * @param {string}   name The action identifier. This is the action_name used by the reporters
     * @param {object}   data The custom data to register for this action
     * @param {function} callback A callback function used to notify consumers on route changes
     * @param {object}   options An object for options to use in transformations or reporters
     *
     */
    var startAction = (0, react_1.useCallback)(function (event, data, callback, options) {
        if (data === void 0) { data = {}; }
        var actionData = __assign(__assign({}, data), { url: url, pathname: pathname });
        startReactAction(event, actionData, function (callbackProps) {
            var step = callbackProps.step, action = callbackProps.action, metric = callbackProps.metric;
            if (!callback) {
                if (step === 'start') {
                    registerPageAction({ action: action, metric: metric });
                }
                else {
                    unregisterPageAction(action);
                }
            }
            else {
                // Register listener
                registerPageActionCallback({ action: action, callback: callback });
                // We need to still register so that we can check if it is not tracked
                registerPageAction({ action: action, metric: metric });
            }
        }, options);
    }, [startReactAction]);
    /**
     * Allows pages to finish measuring custom actions. If an error param is passed in the data,
     * the action is reported as an error instead of success.
     *
     * @param {string} name  The event identifier. This is the action_name used by the reporters
     * @param {object} data  The additional event data
     * @param {boolean} keepAlive  The additional event data
     */
    var endAction = (0, react_1.useCallback)(function (name, data, keepAlive, options, callback) {
        var actionData = __assign(__assign({}, data), { url: url, pathname: pathname });
        endReactAction(name, actionData, keepAlive, options, callback);
    }, [endReactAction]);
    /**
     * Sends a page action with some optional data. Use this function when you don't require
     * to track duration
     *
     * @param {string} name the action name
     * @param {object} data An object to send with the event (be sure the data is accepted by the reports being used)
     * @param {object} options Additional options that will be sent to the reporter
     */
    var trackAction = (0, react_1.useCallback)(function (event, data, options, callback) {
        if (data === void 0) { data = {}; }
        var actionData = __assign(__assign({}, data), { url: url, pathname: pathname });
        trackReactAction(event, actionData, options, callback);
    }, [trackReactAction]);
    /**
     * @deprecated Use startAction instead. This function will no longer be available in the next release
     */
    var measureAction = startAction;
    /**
     * @deprecated Use endAction instead. This function will no longer be available in the next release
     */
    var recordAction = endAction;
    /**
     * @deprecated Use measureAction instead. This function will no longer be available in the next release
     */
    var measureSLI = measureAction;
    /**
     * @deprecated Use recordAction instead. This function will no longer be available in the next release
     */
    var trackSLI = recordAction;
    return (React.createElement(sli_react_metrics_1.PageActionsContext.Provider, { value: {
            getBaseProps: getBaseProps,
            updateMetricData: updateMetricData,
            track: track,
            trackAction: trackAction,
            trackKeepAlive: trackKeepAlive,
            startAction: startAction,
            endAction: endAction,
            measureAction: measureAction,
            recordAction: recordAction,
            measureSLI: measureSLI,
            trackSLI: trackSLI
        } }, children));
};
exports.PageActionsProvider = PageActionsProvider;
